import { render, staticRenderFns } from "./NumberSixSVG.vue?vue&type=template&id=05e737a4&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e737a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e737a4')) {
      api.createRecord('05e737a4', component.options)
    } else {
      api.reload('05e737a4', component.options)
    }
    module.hot.accept("./NumberSixSVG.vue?vue&type=template&id=05e737a4&scoped=true&", function () {
      api.rerender('05e737a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/NumberSixSVG.vue"
export default component.exports